export const GAMANZA_PLAYER_DRAWER_OPEN_EVENT = "gamanza-player-drawer-open";
export const GAMANZA_PLAYER_DRAWER_CLOSE_EVENT = "gamanza-player-drawer-close";

export const openGamanzaPlayerDrawer = () => {
  window.dispatchEvent(new CustomEvent(GAMANZA_PLAYER_DRAWER_OPEN_EVENT));
};

export const closeGamanzaPlayerDrawer = () => {
  window.dispatchEvent(new CustomEvent(GAMANZA_PLAYER_DRAWER_CLOSE_EVENT));
};
